// src/app/services/dirty-form.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DirtyFormService {
  private _isDirty = false;

  /** Marca el formulario como “sucio” */
  setDirty(): void {
    this._isDirty = true;
  }

  /** Resetea la bandera tras guardar o aceptar navegación */
  reset(): void {
    this._isDirty = false;
  }

  /** Devuelve true si hay cambios sin guardar */
  isDirty(): boolean {
    return this._isDirty;
  }
}
